import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import "./IframeContainer.css";

export default function IframeContainer({ src, handleCloseIcon }) {
  const isFullScreen = localStorage.getItem("openInFullScreen");

  return (
    <div
      className={
        isFullScreen ? "showFullScreenIFrame" : "IframeContainer-in-app"
      }
      // style={{
      //   width:document.getElementById("s360-conversation-page").clientWidth-20,
      //   height:document.getElementById("s360-conversation-page").clientHeight-20
      // }}
      style={{
        width: isFullScreen
          ? "100%"
          : document.getElementById("s360-conversation-page").clientWidth - 20,
        height: isFullScreen
          ? "100%"
          : document.getElementById("s360-conversation-page").clientHeight - 20,
          display:'flex',justifyContent:'center',alignItems:'center' 
      }}
    >
      <div className={isFullScreen ?"close-icon-fs" :"close-icon"} onClick={() => handleCloseIcon()}>
        <CloseIcon height="3rem" width="3rem" />
      </div>
      <iframe
        id="s360-chat-iframe-inapp"
        name="s360chatiframe-inapp"
        frameborder="0"
        // src="https://new.simplify360.com/crm/csatNewSurveyDisplay?code=VkhMeUdldXlkdmgyNjJTVEtMZ2gycWVvUjVtOGx4eVFSdjI1MFB1eDF1c3BaR2RncHBoeW9nSWpvdUhFYUtjMHBZYWw0L0hmMzBvSE5WMkpKS24xblE9PQ"
        src={src}
        allowfullscreen="true"
        mozallowfullscreen="true"
        title="chatIframe"
        style={{ width: "98%", height: "95%", padding: "2%",display:'flex',justifyContent:'center',alignItems:'center' }}
      >
        {" "}
      </iframe>
      {/* Return an iframe with 
        src - props.src
        callBack - props.callBack
        ...other props
        design everything here for responsiveness
        */}
    </div>
  );
}
